<template>
	<b-modal :visible="show" :ok-disabled="loadingSubmit" :cancel-disabled="loadingSubmit" :hide-footer="loading"
		@hidden="close" @ok="submit" :ok-title="'modalIndigoDollars.submit' | translate"
		:cancel-title="'modalIndigoDollars.cancel' | translate" :title="'modalIndigoDollars.title' | translate">
		<div v-if="loading" class="loader">
			<loader />
		</div>
		<form v-else @submit.prevent="submit" class="modal-block">
			<p v-if="id">
				<b>{{ 'modalIndigoDollars.balance' | translate }}:
					{{ profile.indigo_dollars || balance }}
				</b>
			</p>

			<label>{{ 'modalIndigoDollars.amount' | translate }}*</label>
			<input type="number" class="form-control mb-2" v-model.number="amount" />

			<label>{{ 'modalIndigoDollars.reason' | translate }}</label>
			<input type="text" class="form-control mb-2" v-model.number="reason" />

			<p v-if="error" class="text-danger">{{ error }}</p>
		</form>
	</b-modal>
</template>

<script>
import Loader from '@/components/Loader'
export default {
	name: 'modal-indigo-dollars',
	components: {
		Loader,
	},
	data: () => ({
		amount: '',
		reason: '',
		loading: false,
		loadingSubmit: false,
		error: '',
		profile: {},
	}),
	props: ['show', 'id', 'groupId', 'balance'],
	watch: {
		id() {
			if (this.id) {
				this.requestProfileData()
			}
		},
		show() {
			this.amount = ''
			this.reason = ''
			this.error = ''
			this.loading = false
			this.loadingSubmit = false
			this.profile = false
		},
	},
	created() {
		if (this.id) {
			this.requestProfileData()
		}
	},
	methods: {
		submit(e) {
			if (e) e.preventDefault()
			this.loadingSubmit = true
			this.axios({
				url: `indigo_dollars/`,
				method: 'post',
				data: {
					user: this.id,
					group: this.groupId,
					amount: +this.amount,
					reason: this.reason,
				},
			})
				.then(({ data }) => {
					this.loadingSubmit = false

					this.$emit('onEndHandler', this.id, this.amount)

					this.close()
				})
				.catch(error => {
					const response = error.response.data.detail
					this.loadingSubmit = false

					if (response && response.non_field_errors) {
						this.error = response.non_field_errors.join('\n')
					} else {
						this.error = 'Error has occurred'
					}
				})
		},

		close() {
			this.$emit('close')
		},

		requestProfileData() {
			this.loading = true
			this.axios({
				url: `users/user/${this.id}`,
			})
				.then(({ data }) => {
					this.profile = data
					this.loading = false
				})
				.catch(() => {
					this.loading = false
				})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button:not(.close) {
	margin: 10px;
}

.loader svg {
	display: block;
	margin: auto;
	width: 100px;
	height: 100px;
}
</style>
